import React from 'react';
import { RootDialog } from 'views/pages/authentication/mfa-components/RootDialog';
import TenantSelectorContent from 'views/pages/authentication/SelectTenant/components/TenantSelectorContent';
import { useTenantSelector } from 'contexts/TenantSelectorContext';

interface TenantSelectionDialogContentProps {
    open: boolean;
}

const DIALOG_STYLES = {
    borderRadius: '8px',
    padding: 0,
    margin: 0,
    width: 500
} as const;

const TenantSelectionDialogContent = ({ open }: TenantSelectionDialogContentProps) => {
    const { handleClose } = useTenantSelector();

    return (
        <RootDialog
            fullWidth
            maxWidth="sm"
            onClose={handleClose}
            aria-labelledby="tenant-selection-dialog"
            open={open}
            PaperProps={{ sx: DIALOG_STYLES }}
        >
            <TenantSelectorContent />
        </RootDialog>
    );
};

export default TenantSelectionDialogContent;
